<!--
  Cross Assessment
-->
<div
  *ngIf="
    crossAssessment &&
    crossAssessment.createdByOrg &&
    crossAssessment.crossReferenceType !== 'NO_MATCH' &&
    !showAddCross()
  "
>
  <app-assessment-notes
    [canAddNotes]="permissions?.ADD_CROSS_REFERENCE_NOTE?.hasAccess && !user?.isGPO"
    [crossReferenceOpinionOptions]="crossReferenceOpinionOptions"
    [canUpdateOpinion]="
      permissions?.CHANGE_CROSS_REFERENCE_OPINION?.hasAccess &&
      (!crossCreatedByUserOrg || isSellerCross)
    "
    (createNote)="onAddNote($event)"
    (updateOpinion)="onUpdateOpinion($event)"
    [notes]="crossAssessment.notes"
  >
  </app-assessment-notes>

  <app-clinical-assessment-vote
    [canUpdateOpinion]="permissions?.CHANGE_CROSS_REFERENCE_OPINION?.hasAccess && !user?.isGPO"
    [disputeCount]="crossAssessment.marketplaceDisputeCount"
    [approveCount]="crossAssessment.marketplaceApproveCount"
    [crossOpinion]="crossAssessment.opinion?.opinion"
    (updateOpinion)="onUpdateOpinion($event)"
  >
  </app-clinical-assessment-vote>
</div>

<!--
  Add-Cross button - if permission available
-->
<div
  *ngIf="this.permissions?.UPDATE_CROSS_REFERENCE?.hasAccess && showAddCross()"
  class="add-cross-button"
>
  <button
    data-test-selector="assessment-add-cross"
    type="button"
    class="btn btn-outline-dark"
    (click)="onAddCross()"
  >
    Add Cross
  </button>
</div>
